import { render } from "./EzerModal.vue?vue&type=template&id=5375d156"
import script from "./EzerModal.vue?vue&type=script&lang=js"
export * from "./EzerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__